export default "__VITE_ASSET__93a68144__"